import { render, staticRenderFns } from "./PersonalUpdate.vue?vue&type=template&id=d54aaaf4&"
import script from "./PersonalUpdate.vue?vue&type=script&lang=js&"
export * from "./PersonalUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PersonalUpdate.vue?vue&type=style&index=0&id=d54aaaf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports